import { has, get, split, contains, flow } from 'lodash/fp';

const VIEW = 'VIEW';
const MODIFY = 'MODIFY';
const FULL = 'FULL';

export const viewAccess = name => `${VIEW}:${name}`;
export const modifyAccess = name => `${MODIFY}:${name}`;
export const fullAccess = name => `${FULL}:${name}`;

export const hasViewAccess = (permission, permissions) =>
  has(`${VIEW}:${permission}`, permissions);

export const hasModifyAccess = (permission, permissions) =>
  has(`${MODIFY}:${permission}`, permissions);

export const hasFullAccess = (permission, permissions) =>
  has(`${FULL}:${permission}`, permissions);

export const isFullAccess = contains(`${FULL}:`);

export const isModifyAccess = contains(`${MODIFY}:`);

export const createModifyAndViewPermission = flow(
  split(':'),
  get(1),
  permission => [modifyAccess(permission), viewAccess(permission)]
);

export const createViewPermission = flow(
  split(':'),
  get(1),
  permission => viewAccess(permission)
);

export const breakoutPermission = permission => {
  if (isFullAccess(permission))
    return [permission, ...createModifyAndViewPermission(permission)];
  if (isModifyAccess(permission))
    return [permission, createViewPermission(permission)];
  return [permission];
};
